import React from 'react';

export class AdministratorDashboard extends React.Component {
  render() {
    return (
      <div className="administrator-dashboard">
        <div className="admin-container">
          <div className="row">
            <div className="col">
              <div className="admin-blocks students">
                <div className="admin-icon">
                </div>
                <div className="admin-text">
                  Total Students
                  <span>290</span>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="admin-blocks teachers">
                <div className="admin-icon">
                </div>
                <div className="admin-text">
                  Total Teachers
                  <span>56</span>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="admin-blocks classes">
                <div className="admin-icon">
                </div>
                <div className="admin-text">
                  Total Classes
                  <span>310</span>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="admin-blocks courses">
                <div className="admin-icon">
                </div>
                <div className="admin-text">
                  Total Courses
                  <span>421</span>                  
                </div>
              </div>
            </div>
            <div className="col">
              <div className="admin-blocks revenue">
                <div className="admin-icon">
                </div>
                <div className="admin-text">
                  Total Revenue
                  <span>23 120$</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
